'use strict';/* global define:false */define('modules/tie/index',['angular','./directives/tie-directive'],function(ng,tieDirective){'use strict';/**
   * tie
   * ===
   *
   */return ng.module('pa:tie',[]).directive('tie',tieDirective);});
